import React, {useState} from "react";
import {Box, Grid, IconButton, Typography,} from "@mui/material";
import {useTranslation} from "react-i18next";
import i18n from "@/config/i18n";
import Check from '@mui/icons-material/Check';
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Divider from '@mui/material/Divider';
import {ChangeLog, UpdateDate, CurrentVersion, HistoriesVersion} from "@/utils/ChangeLogs";
import DescriptionIcon from '@mui/icons-material/Description';



type UpdateLogEntry = {
  version: string;
  date: string;
  changes: string[];
};

// 定义按年份分组的更新日志类型
type GroupedUpdateLogs = {
  [year: string]: UpdateLogEntry[];
};


const ChangeLogs: React.FC = () => {
  const {t} = useTranslation();
  const currentLng = i18n.language;
  const current_version = CurrentVersion;
  const change_log = ChangeLog;
  const update_date = UpdateDate;
  const historiesLogs: UpdateLogEntry[] = HistoriesVersion;

  const groupedLogs: GroupedUpdateLogs = historiesLogs.reduce((acc: GroupedUpdateLogs, log: UpdateLogEntry) => {
    const year = log.date.split('-')[0];
    if (!acc[year]) {
      acc[year] = [];
    }
    acc[year].push(log);
    return acc;
  }, {});
  const sortedYears = Object.keys(groupedLogs).sort((a, b) => Number(b) - Number(a));
// 管理年份的折叠状态
  const [yearExpanded, setYearExpanded] = useState<{ [year: string]: boolean }>({});
// 管理小版本的折叠状态
  const [versionExpanded, setVersionExpanded] = useState<{ [key: string]: boolean }>({});

  const handleYearToggle = (year: string) => {
    setYearExpanded((prev) => ({
      ...prev,
      [year]: !prev[year]
    }));
  };

  const handleVersionToggle = (key: string) => {
    setVersionExpanded((prev) => ({
      ...prev,
      [key]: !prev[key]
    }));
  };
  return (
    <Grid sx={{
      // height: "80%",
      overflowY: "auto"
    }}>
      <Typography
        sx={{
          p: 2,
          width: "550px",
          backgroundColor: "rgb(255,255,255)",
        }}
      >
        <h3 style={{color: "#999999", marginTop: "-10px"}}>Change Logs</h3>
        <Divider />
        <Typography style={{
          marginTop: "10px",
          color: "#000000",
          fontSize: "18px",
          fontWeight: "bold"
        }}>{current_version}</Typography>
        <Typography sx={{color: "#999999", fontSize: "16px"}}>{t("common.Update Date")}{update_date}</Typography>
        <ul style={{marginLeft: "-40px"}}>
          {change_log.map((log: any, logIndex) => (
            <Grid key={logIndex} sx={{display: "flex"}}>
              <Grid>
                <Check sx={{color: "#2BA9DE", mr: 1}}/>
              </Grid>
              <Grid>
                {log}
              </Grid>
            </Grid>
          ))}
        </ul>
        <Divider />
        <Typography style={{
          color: "#000000",
          fontSize: "18px",
          marginTop: "10px",
          fontWeight: "bold"
        }}>History version</Typography>
        {sortedYears.map((year) => {
          const logs = groupedLogs[year];
          return (
            <div key={year}>
              <div style={{display: 'flex', alignItems: 'center'}}>
                <IconButton onClick={() => handleYearToggle(year)}>
                  {yearExpanded[year] ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
                </IconButton>
                <Typography>{year}</Typography>
              </div>
              {yearExpanded[year] && (
                <div style={{marginLeft: 24}}>
                  {logs.map((log) => {
                    const key = `${year}-${log.version}`;
                    return (
                      <div key={key}>
                        <div style={{display: 'flex', alignItems: 'center'}}>
                          <IconButton onClick={() => handleVersionToggle(key)}>
                            {versionExpanded[key] ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
                          </IconButton>
                          <Typography>
                            {t("common.version")}{` ${log.version} - ${log.date}`}
                          </Typography>
                        </div>
                        {versionExpanded[key] && (
                          <ul style={{marginLeft: 24}}>
                            {log.changes.map((change, changeIndex) => (
                              <Grid key={changeIndex} sx={{display: "flex"}}>
                                <Grid>
                                  <Check sx={{color: "#2BA9DE", mr: 1}}/>
                                </Grid>
                                <Grid>
                                  {change}
                                </Grid>
                              </Grid>
                            ))}
                          </ul>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
        <Divider />
        <Box>
          <Grid>
            <Typography style={{
              color: "#000000",
              fontSize: "18px",
              marginTop: "10px",
              fontWeight: "bold"
            }}>{t("common.Functional operation guide")}</Typography>
          </Grid>
          <Box
            sx={{
              border: '1px solid #ccc',
              borderRadius: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              backgroundColor: '#ffffff',
              mt: 2,
            }}
          >
            <Grid container alignItems="center">
              <Grid item>
                <IconButton disableRipple>
                  <DescriptionIcon />
                </IconButton>
              </Grid>
              <Grid item>
                <a
                  href={`https://ngteco-office-prod.s3.us-east-1.amazonaws.com/market/${currentLng}/User+Manual.pdf`}
                  target="_top"
                  rel="noopener noreferrer"
                  style={{color: "#2BA9DE", textDecoration: 'none', marginLeft: '10px'}}
                >
                  {t("common.User Manual Guide (PDF)")}
                </a>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Typography>
    </Grid>
  );
};
export default ChangeLogs;
